import {
  ConfigurationMissingHandlingComponent,
  DOMAIN_REDIRECT_URL_PATH,
  DomainRedirectComponent,
  GithubCallbackComponent,
  GithubInstallationCallbackComponent,
  HelpCenterComponent,
  NoPluginHandlingComponent,
  NoVPNHandlingComponent,
  ThemeSelectorComponent,
} from './components';
import { ErrorComponent } from './components/error/error.component';
import { ExtensionTrustDialogComponent } from './components/extension-trust-dialog/extension-trust-dialog.component';
import { Routes } from '@angular/router';

export const dxpRoutes: Routes = [
  {
    path: 'github',
    component: GithubCallbackComponent,
  },
  {
    path: 'github-installation',
    component: GithubInstallationCallbackComponent,
  },
  {
    path: DOMAIN_REDIRECT_URL_PATH,
    component: DomainRedirectComponent,
    children: [
      {
        path: '**',
        component: DomainRedirectComponent,
      },
    ],
  },
  { path: 'error-handling', component: ErrorComponent },
  { path: 'help', component: HelpCenterComponent },
  { path: 'no-plugin-handling', component: NoPluginHandlingComponent },
  {
    path: 'extension-trust-handling',
    component: ExtensionTrustDialogComponent,
  },
  { path: 'no-vpn-handling', component: NoVPNHandlingComponent },
  {
    path: 'configuration-missing-handling',
    component: ConfigurationMissingHandlingComponent,
  },
  { path: 'settings-theming', component: ThemeSelectorComponent },
];
